import { render, staticRenderFns } from "./recActivityParticipant.vue?vue&type=template&id=b8cd1d08&"
import script from "./recActivityParticipant.vue?vue&type=script&lang=js&"
export * from "./recActivityParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports